import { useParams } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@/frontend/components/ui/dialog";
import { FirstWinCelebration } from "@/frontend/components/onboarding/FirstWinCelebration";
import { useProductTourStore } from "@/frontend/stores/productTourStore";

// Linking the WhatsApp app finishes onboarding by itself and opens the Inbox,
// so its celebration is shown there instead of on the onboarding screen.
export function FirstWinDialog() {
  const { orgId } = useParams<{ orgId: string }>();
  const open = useProductTourStore((state) => !!orgId && state.firstWin?.orgId === orgId);
  const close = useProductTourStore((state) => state.closeFirstWin);
  const queue = useProductTourStore((state) => state.queue);
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) close(); }}>
      <DialogContent className="sm:max-w-md" aria-describedby={undefined}>
        <FirstWinCelebration
          title="Congrats! WhatsApp is connected"
          titleAs={DialogTitle}
          body="Your chats are syncing now, and new messages will land in your Inbox as they arrive."
          nextSteps={[
            "Give it a few minutes for your recent chats to show up.",
            "Ask someone to message your number and watch it arrive.",
            "Turn on an AI Agent so customers get a reply even when you're away.",
          ]}
          actionLabel="Show me around"
          onContinue={() => {
            close();
            if (orgId) queue(orgId, "inbox");
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
